import dayjs from 'dayjs';
import type { ReportFormat } from '../../../types/reportDashboard';
import { formatValue } from '../format';

/** Figures on the Ops report, as her sheet writes them. */
export function formatReportValue(v: number | null | undefined, format: ReportFormat): string {
  if (v === null || v === undefined || Number.isNaN(v)) return '—';
  switch (format) {
    case 'pct':
      return `${v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`;
    case 'days':
      return v.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    // Short, as every board writes a premium total: $1.28M, $340K.
    case 'money':
      return formatValue(v, 'money');
    default:
      return Math.round(v).toLocaleString('en-US');
  }
}

/** "Feb 3, 2026". */
export const shortDate = (iso: string | null | undefined): string => (iso ? dayjs(iso).format('MMM D, YYYY') : '—');

export const money = (v: number | null | undefined): string =>
  v === null || v === undefined ? '—' : `$${Math.round(v).toLocaleString('en-US')}`;
